import React from "react";
import JumboContentLayout from "@jumbo/components/JumboContentLayout";
import Header from "./header";
import { BookingProvider, useBookingContext } from "./context";
import CalendarBasic from "./calendars/CalendarBasic";
import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import BookingForm from "./BookingForm";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Typography } from "@mui/material";

const Children = () => {
  return (
    <BookingProvider>
      <InnerChildren />
    </BookingProvider>
  );
};

const InnerChildren = () => {
  const { globalState, setGlobalState } = useBookingContext();
  const { t } = useTranslation();

  return (
    <JumboContentLayout
      layoutOptions={{}}
      //sidebar={<Sidebar/>}
      header={
        <Header
          title={<Typography
          sx={{
            fontSize: "28px",
            fontWeight: 600,
            color: "#002465",
            fontFamily: "'Nunito', sans-serif",
          }}
        >
          {t("parent.title.bookingTitleNew")}
        </Typography>}
          subheader={
            <Typography
                sx={{
                  color: "#666",
                  fontSize: "16px",
                  fontFamily: "'Nunito', sans-serif",
                }}
            >
              {t("parent.title.bookingSubheaderNew")}
            </Typography>
          }
        />
      }
    >
      <CalendarBasic />

      <Dialog
        open={globalState.addEditBooking}
        onClose={() =>
          setGlobalState((prev) => ({ ...prev, addEditBooking: false }))
        }
      >
        <DialogTitle>
            <Typography
                component="span"
                sx={{
                    fontSize: "22px",
                    fontWeight: 800,
                    color: "#002465",
                    fontFamily: "'Nunito', sans-serif",
                }}
            >
                {t("calendar.bookingForm")}
            </Typography>
          <IconButton
            aria-label="close"
            onClick={() =>
              setGlobalState((prev) => ({
                ...prev,
                addEditBooking: false,
              }))
            }
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: "#FFF",
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent>
          <BookingForm />
        </DialogContent>
      </Dialog>
    </JumboContentLayout>
  );
};

export default Children;
